import { useMemo, useRef, type ReactNode } from "react";

import { TourTargetsContext, type TourTargetsContextValue } from "./TourTargetsContext";

type TourTargetsProviderProps = {
  children: ReactNode;
};

export function TourTargetsProvider({ children }: TourTargetsProviderProps) {
  const elements = useRef(new Map<string, HTMLElement>());

  const value = useMemo<TourTargetsContextValue>(
    () => ({
      register: (name, element) => {
        elements.current.set(name, element);
      },
      unregister: (name, element) => {
        if (elements.current.get(name) !== element) return;
        elements.current.delete(name);
      },
      get: (name) => {
        const element = elements.current.get(name);
        return element?.isConnected ? element : null;
      },
    }),
    [],
  );

  return <TourTargetsContext.Provider value={value}>{children}</TourTargetsContext.Provider>;
}
